import * as React from "react";

class MenuBackground extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="menu-background"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 367.2 1080"
      >
        <path
          fill="none"
          stroke="#EF7757"
          strokeWidth="2.8346"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M94,1067.4c0,0-14.9-47.1,15.4-92.5c26.1-39.1,67-46,73.3-46.9c0.5-0.1,0.9-0.4,1-0.9c0.9-5.3,7-34.5,31.6-51.1
	c32-21.6,65-11.4,71.1-9.2c0.6,0.2,1.2-0.1,1.4-0.6c3.1-7,24-48.8,76-35.9"
        />
        <line
          fill="none"
          stroke="#EF7757"
          strokeWidth="5.6693"
          strokeLinecap="round"
          strokeMiterlimit="10"
          x1="244.8"
          y1="916.3"
          x2="244.8"
          y2="920"
        />
        <line
          fill="none"
          stroke="#EF7757"
          strokeWidth="5.6693"
          strokeLinecap="round"
          strokeMiterlimit="10"
          x1="257.3"
          y1="916.3"
          x2="257.3"
          y2="920"
        />
        <path
          fill="none"
          stroke="#EF7757"
          strokeWidth="2.8346"
          strokeLinecap="round"
          strokeMiterlimit="10"
          d="M256,930.1c0,0,0.5,7.1-5.5,7.1c-5.5,0-4.9-7.1-4.9-7.1H256z"
        />
        <path
          fill="none"
          stroke="#EF7757"
          strokeWidth="2.8346"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M19.9,865.8c0,0,25.8,10.6,34.5,35.1c7.3,20.7,7,39.6,6.7,45.1c0,0.8,0.7,1.3,1.4,1.1
	c5.7-1.4,26.8-4.9,48.9,14.1"
        />
        <path
          fill="none"
          stroke="#5D82B4"
          strokeWidth="2.8346"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M227.1,862.5c0,0-6.5-21-34.4-28.3c-27.7-7.3-45.3,7.2-49,10.6c-0.4,0.4-1,0.4-1.5,0.1
	c-2.7-2.2-12.4-8.9-25.2-5.5c-13.4,3.7-17.4,15.8-18.3,19c-0.1,0.5-0.5,0.8-1,0.8c-4.9,0.5-30.9,4.2-36.1,33.1"
        />
        <circle fill="#5D82B4" cx="140.2" cy="912.5" r="3" />
        <circle fill="#5D82B4" cx="150.8" cy="912.5" r="3" />
        <line
          fill="none"
          stroke="#EF7757"
          strokeWidth="5.6693"
          strokeLinecap="round"
          strokeMiterlimit="10"
          x1="71.2"
          y1="973.1"
          x2="72.7"
          y2="975.2"
        />
        <line
          fill="none"
          stroke="#EF7757"
          strokeWidth="5.6693"
          strokeLinecap="round"
          strokeMiterlimit="10"
          x1="77.1"
          y1="967.4"
          x2="78.6"
          y2="969.5"
        />
        <path
          fill="none"
          stroke="#EF7757"
          strokeWidth="2.8346"
          strokeMiterlimit="10"
          d="M73.4,983.5c0,0,5.2,1.6,12.1-4.2"
        />
      </svg>
    );
  }
}

export default MenuBackground;



// WEBPACK FOOTER //
// ./src/common/menu/components/MenuBackground.tsx